<div *ngIf="!isLoading else loader" style="margin-top: 24px;" class="invoice-container mx-auto">
  <div ngbDropdown class="pt-4 print-hide">
    <button style="float:left;" class="btn btn-outline-primary btn_align" id="dropdownMenuActiveItem" *ngIf="!commonService.isMobileView" ngbDropdownToggle>
      SaveAs</button>
    <div class="list_fixed" ngbDropdownMenu aria-labelledby="dropdownMenuActiveItem">
      <button ngbDropdownItem (click)="download('png')"><i class="link-icon feather icon-image"></i> PNG</button>
      <button ngbDropdownItem (click)="download('pdf')"><i class="link-icon feather icon-file-text"></i> PDF</button>
    </div>
  </div>
  <div #invoice class="p-3 bg-white">

    <div class="row  mt-2 mb-5 d-flex align-items-center">

      <div class="col-6">
        <img [src]="bannerImage" class="logo">
      </div>
      <div class="col-6 text-right">
        <dt class="fs-4"> Created on </dt>
        <dd class="fs-4"> {{id.createdAt | dateTimePipe}} </dd>
        <dt class="fs-4"> Invoice Number </dt>
        <dd class="fs-4"> {{id.invoiceNumber}}</dd>
        <dt class="fs-4"> Payment Status </dt>
        <dd class="fs-4"> {{id.status}}</dd>
      </div>
    </div>
    <hr />

    <div class="row mt-3 mb-5 d-flex">
      <div class="col-6">
        <h4 class="gray-text mb-2">
          Bill From
        </h4>
        <p class="fs-3">{{md?.dba}}</p>
        <p class="fs-4" *ngIf="md?.email">
          <span class="mdi mdi-email-outline" aria-hidden></span>
          {{md.email}}
        </p>
        <p class="fs-4" *ngIf="md?.phoneNumber">
          <span class="mdi mdi-phone-outline" aria-hidden></span>
          {{md.phoneNumber}}
        </p>

        <p class="fs-4" *ngIf="md?.state">
          <span class="mdi mdi-city-variant-outline" aria-hidden></span>

          {{md.state}} , {{md.city}}
        </p>


      </div>

      <div class="col-6 text-right">
        <h4 class="gray-text mb-2">
          Bill to
        </h4>
        <p class="fs-3" [ngClass]="cd.firstName ? 'd-block' : 'invisible'"> {{cd?.firstName + ' ' + (cd.lastName ?
          cd.lastName : '') }} </p>
        <p class="fs-4" *ngIf="cd?.email">
          {{cd.email}}

          <span class="mdi mdi-email-outline" aria-hidden></span>

        </p>
        <p class="fs-4" *ngIf="cd?.phone">
          {{cd.phone}}

          <span class="mdi mdi-phone-outline" aria-hidden></span>

        </p>

        <p class="fs-4" *ngIf="cd?.state">

          {{cd.state}} , {{cd.city}}

          <span class="mdi mdi-city-variant-outline" aria-hidden></span>

        </p>
      </div>

    </div>



    <div class="p-2 bluebackground rounded">
      <h4> Invoice </h4>
    </div>

    <p-table [columns]="cols" [value]="lineItemDetails" responsiveLayout="scroll" columnResizeMode="expand">
      <ng-template pTemplate="header">
        <tr class="fs-1-5">
          <th *ngFor="let col of cols" [ngStyle]="{'width' : col.width}">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="fs-1-5">
          <td> {{item.code}}</td>
          <td> {{item.productName}}</td>
          <td> {{item.unitCost | toDollars}}</td>
          <td> {{item.quantity}}</td>
          <td> {{item.discountAmount | toDollars}}</td>
          <td style="word-break: break-all"> {{item.description}}</td>
          <td> {{item.totalTax | toDollars}}</td>
          <td> {{item.totalAmount | toDollars}}</td>

        </tr>
      </ng-template>
    </p-table>

    <div class="p-2 rounded row align-items-center mt-4 px-0 d-flex flex-wrap">
      <div class="col flex-grow-1">
        <dd class="fs-3-5 mb-0 gray-text"> Total Discount </dd>
        <dt class="fs-3-5"> {{totalDiscount | toDollars }} </dt>
      </div>
      <div class="col flex-grow-1">
        <dd class="fs-3-5 mb-0 gray-text"> Total Tax </dd>
        <dt class="fs-3-5 "> {{totalTax | toDollars}} </dt>
      </div>
      <div class="col flex-grow-1">
        <dd class="fs-3-5 mb-0 gray-text"> Shipping Fee </dd>
        <dt class="fs-3-5 "> {{shippingFee | toDollars }} </dt>
      </div>
      <div class="col flex-grow-1" [ngClass]="(td?.customFee || td?.surcharge) ? '' : 'invisible'">
        <dd class="fs-3-5 mb-0 gray-text"> Fee </dd>
        <dt class="fs-3-5 "> {{(td?.customFee || td?.surcharge) | toDollars }} </dt>
      </div>
      <div class="col flex-grow-1" *ngIf="paidChildInvoicesTotal > 0">
        <dd class="fs-3-5 mb-0 gray-text"> Paid </dd>
        <dt class="fs-3-5"> {{ paidChildInvoicesTotal | toDollars }} </dt>
      </div>
      <div class="col flex-grow-1">
        <dd class="fs-3-5 mb-0 gray-text"> Total </dd>
        <dt class="fs-3-5 "> {{ totalAmount | toDollars }} </dt>
      </div>
    </div>
  </div>

</div>

<ng-template #loader>
  <app-loading></app-loading>
</ng-template>